import {type EventLog, TagType} from '../../model';
import {Tag} from '../atoms';
import {formatDateUTC} from "../../utils/lib";
import {useState} from 'react';
import {useTimezone} from '../../hooks';

type EventLogRowProps = {
    eventLog: EventLog;
}

const MAX_PREVIEW_LENGTH = 150;

const FormatDateWithBreak = ({ date, formatter = 'long' }: { date: string | Date, formatter?: 'short' | 'long' }) => {
    const timezone = useTimezone();
    const formatted = formatDateUTC(date, formatter, timezone);
    const parts = formatted.split(' ');
    const datePart = parts.slice(0, 3).join(' ');
    const timePart = parts[3];

    return (
        <div>
            <div>{datePart}</div>
            <div>{timePart}</div>
        </div>
    );
};

export const EventLogRow = ({eventLog}: EventLogRowProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const description = eventLog.description || '';
    const isLong = description.length > MAX_PREVIEW_LENGTH;
    const displayText = isExpanded || !isLong
        ? description
        : `${description.substring(0, MAX_PREVIEW_LENGTH)}...`;

    return (
        <tr className="border-b border-neutral-100">
            <td className="py-3">
                <Tag type={TagType.Neutral}>{eventLog.eventCode}</Tag>
            </td>
            <td className="max-w-md py-3">
                <div className="break-words break-all">
                    {displayText}
                </div>
                {isLong && (
                    <button
                        className="mt-1 text-xs text-brand-1 hover:text-brand-1/80 underline cursor-pointer"
                        onClick={() => setIsExpanded(!isExpanded)}
                        type="button"
                    >
                        {isExpanded ? 'Скрыть' : 'Показать полностью'}
                    </button>
                )}
            </td>
            <td className="py-3">
                <FormatDateWithBreak date={eventLog.eventTime} formatter="long"/>
            </td>
            <td className="py-3">{eventLog.userId}</td>
        </tr>
    );
};
